<template>
  <a
    class="dropdown-sub-item c-orange d-flex align-items-center shadow border-radius bg-white p-1 no-text-decoration col-6 mt-2"
    :href="`${link}`"
    :target="`${target}`"
  >
    <div class="d-flex w-100 col-12 align-items-center">
      <i :class="`${icon} menu-icon d-flex fs-18 mr-2`"></i>
      <span class="c-black fs-15">
        {{ text }}
      </span>
    </div>
  </a>
</template>
<script>
export default {
  props: {
    link: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.border-radius {
  border-radius: 8px;
}

.no-text-decoration:hover {
  color: var(--orange-primary);
  text-decoration: none;
}
</style>
